import React from 'react';

interface props {
  size?: string | number;
}

const IconeBotWhatsapp: React.FC<props> = ({ size = '28' }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <defs>
      <linearGradient id="green" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#25D366" />
        <stop offset="100%" stopColor="#00A884" />
      </linearGradient>
    </defs>

    <path
      d="M256 32C132.3 32 32 130.6 32 252c0 45.5 14 87.8 37.9 122.7L38 480l108.2-30.8C179.4 466.2 216.4 472 256 472c123.7 0 224-98.6 224-220S379.7 32 256 32Z"
      fill="url(#green)"
      stroke="#fff"
      strokeWidth="14"
      strokeLinejoin="round"
    />

    <circle cx="256" cy="104" r="16" fill="#fff" />
    <rect x="250" y="116" width="12" height="32" rx="6" fill="#fff" />

    <rect x="145" y="140" width="222" height="142" rx="62" fill="#fff" />

    <rect x="126" y="184" width="28" height="64" rx="14" fill="#fff" />
    <rect x="358" y="184" width="28" height="64" rx="14" fill="#fff" />

    <rect x="170" y="166" width="172" height="92" rx="36" fill="#008F65" />

    <circle cx="218" cy="205" r="11" fill="#fff" />
    <circle cx="294" cy="205" r="11" fill="#fff" />

    <path
      d="M235 225 Q256 244 277 225"
      fill="none"
      stroke="#fff"
      strokeWidth="8"
      strokeLinecap="round"
    />

    <path
      d="M174 292
       Q256 270 338 292
       L360 344
       Q362 360 342 360
       H170
       Q150 360 152 344
       Z"
      fill="#fff"
    />

    <circle cx="228" cy="327" r="8" fill="#008F65" />
    <circle cx="256" cy="327" r="8" fill="#008F65" />
    <circle cx="284" cy="327" r="8" fill="#008F65" />
  </svg>
);

export default IconeBotWhatsapp;
